import { AdContainer } from "./ad-container";

interface FluidAdProps {
  slot?: string;
  className?: string;
}

export function FluidAd({ slot, className }: FluidAdProps) {
  return <AdContainer format="fluid" slot={slot} className={className} />;
}
